import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ClientProvider from "../../../modules/ClientProvider";
import { IScheduler } from "../../../types/database/Scheduler";

export const useSchedulers = (projectTag: string) => {
    const [schedulers, setSchedulers] = useState<IScheduler[]>([]);
    const [fetched, setFetched] = useState(false);
    const [error, setError] = useState(null);
    const { getAccessTokenSilently } = useAuth0();

    const schedulerClient = ClientProvider.provideSchedulerClient();

    const loadSchedulers = async () => {
        if (!projectTag) return;
        
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await schedulerClient.getSchedulers(projectTag, accessToken);

        if (data) {
            setSchedulers(data.schedulers || []);
            setFetched(true);
        } else {
            setError(error?.message);
            setSchedulers([]);
        }
    };

    useEffect(() => {
        loadSchedulers();
    }, [projectTag, getAccessTokenSilently]);

    return {
        fetched,
        schedulers,
        error,
        reloadSchedulers: loadSchedulers
    };
}; 